import { Link } from 'react-router-dom'
import './AuthShell.css'

/**
 * Shared frame for every authentication screen.
 *
 * Replaces the old `.public` + `.login` + `.form` stack, where `.login`
 * capped at 400px while the `.form` inside it asked for 500px — the form
 * overflowed its container and sat visibly off-centre. One panel owns the
 * width here, so that cannot recur.
 *
 * @param {string}   eyebrow  small letterspaced label above the title
 * @param {string}   title    the heading
 * @param {string}   subtitle optional supporting line
 * @param {Array}    links    [{ to, label }] rendered in the footer
 */
const AuthShell = ({ eyebrow, title, subtitle, children, links = [] }) => (
    <section className="auth">
        <div className="auth__panel">
            <header className="auth__head">
                {eyebrow && <p className="auth__eyebrow">{eyebrow}</p>}
                <h1 className="auth__title">{title}</h1>
                {subtitle && <p className="auth__subtitle">{subtitle}</p>}
                <div className="auth__rule" aria-hidden="true">
                    <span className="auth__diamond" />
                </div>
            </header>

            {children}
        </div>

        {links.length > 0 && (
            <nav className="auth__links">
                {links.map(({ to, label }) => (
                    <Link key={to} to={to} className="auth__link">{label}</Link>
                ))}
            </nav>
        )}
    </section>
)

export default AuthShell
